<template>
  <div>
    <SuccessPayment v-if="success" :info="data"/>
    <FailedPayment v-if="failed" :info="data"/>
  </div>
</template>

<script>
import SuccessPayment from "@/view/pages/payment-callback-new/SuccessPayment";
import FailedPayment from "@/view/pages/payment-callback-new/FailedPayment";

export default {
  components: {FailedPayment, SuccessPayment},
  data() {
    return {
      data: null,
      success: false,
      failed: false,
      authority: undefined,
      message: undefined,
    }
  },
  mounted() {
    const {
      authority,
      message,
      status
    } = this.$route.query;

    this.success = status === 'true';
    this.failed = status === 'false';
    this.message = message;
    this.authority = authority;

    this.checkPayment();
  },
  methods: {
    checkPayment() {
      if (this.success)
        this.$toast.success("شارژ کیف پول با موفقیت انجام شد")
      else
        this.$toast.error(this.message)

      this.requestApiGet('newWallet/get/payment/detail?authority=' + this.authority)
          .then(({data}) => {
            this.data = data.data
            // this.$router.replace({'query': null});
          })
          .catch(({response}) => {
            this.data = response.data.order
            // this.$router.replace({'query': null})
            this.success = false;
            this.failed = true;
          });
    }
  }
}
</script>
